import classNames from "classnames";
import { t } from "i18next";
import React, { useEffect } from "react";
import { Svg, SVG_ICONS } from "../__common/Svg/Svg";
import { Typography } from "../__common/Typography/Typography";
import "./NoDataMessage.scss";
import { useCookie } from "../../hooks/cookie-hooks";

type NoDataMessageProps = {
  className?: string;
  page?: string;
};

export const NoDataMessage = ({ className, page }: NoDataMessageProps) => {
  const classes = classNames("message-container empty_services", className);
  const { isShowNotice } = useCookie();
  useEffect(() => {
    // Check if the current page is the history page
    if (page !== "history") return () => {};

    // Access DOM elements for styling adjustments
    const mainBody = document.getElementById("main-body");
    const layoutContainer = document.getElementById("layout-container");
    const serviceRequestErrorToast = document.getElementById(
      "service-request-error-toast"
    );
    const helptipsPopup = document.getElementById("helptipsPopup");

    // Apply specific styles and classes for history page layout
    if (serviceRequestErrorToast) {
      serviceRequestErrorToast.classList.add("serviceToastNoData");
    }
    if (helptipsPopup && isShowNotice) {
      helptipsPopup.classList.add("helptipsPopupNoData");
    }
    if (layoutContainer && mainBody) {
      mainBody.style.display = "flex";
      mainBody.style.flexDirection = "column";
      layoutContainer.style.minHeight = "unset";
      layoutContainer.style.display = "flex";
      layoutContainer.style.flexDirection = "column";
      layoutContainer.style.flex = "1";
    }

    // Cleanup function to reset styles on component unmount or page change
    return () => {
      if (serviceRequestErrorToast) {
        serviceRequestErrorToast.classList.remove("serviceToastNoData");
      }
      if (helptipsPopup) {
        helptipsPopup.classList.remove("helptipsPopupNoData");
      }
      if (layoutContainer && mainBody) {
        layoutContainer.removeAttribute("style");
        mainBody.removeAttribute("style");
      }
    };
  }, [page, isShowNotice]);

  return (
    <div className={classes}>
      <Svg
        icon={SVG_ICONS.CHINA_NODATA}
        width={64}
        height={64}
        testId="nodata-svg"
      />
      <Typography variant="body1" weight="w500" testId="nodata-message" className="subText">
        {t("PRIVACY_MYDATA_SUMMARY_LABEL_NODATA")} <br />
      </Typography>
    </div>
  );
};
